import {Dimensions, StyleSheet} from 'react-native';
import {colorPalette, defaultTheme, textStyles} from '../../../../theme';

export default StyleSheet.create({
  title: {marginTop: 24, marginHorizontal: 0},
  button: {
    marginTop: 10,
    marginBottom: 24,
    marginHorizontal: 16,
  },
  container: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'flex-end',
    alignItems: 'center',
    zIndex: 100,
    backgroundColor: 'rgba(0,0,0,0.3)',
    position: 'absolute',
  },
  content: {
    backgroundColor: defaultTheme.colors.whiteGrey0,
    width: Dimensions.get('window').width,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    zIndex: 1000,
    position: 'absolute',
    bottom: 0,
  },
  indicator: {
    backgroundColor: colorPalette.secondaryLighter2,
    height: 2,
    width: 36,
    marginTop: 10,
    marginBottom: 4,
    alignSelf: 'center',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    alignSelf: 'flex-end',
    width: '100%',
    paddingHorizontal: 10,
  },
  backButton: {
    alignSelf: 'flex-end',
    marginTop: 10,
    marginBottom: -3,
    marginRight: 16,
    marginRight: 'auto',
  },
  screenTitle: {
    fontFamily: textStyles.regular,
    fontSize: 15,
    color: colorPalette.grey9,
    marginRight: 8,
    marginTop: 10,
  },
  inputLeft: {
    fontFamily: textStyles.regular,
    fontSize: 12,
    color: colorPalette.primary,
  },
  input: {
    marginTop: 20,
    marginHorizontal: 16,
  },
  inputStyle: {
    flex: undefined,
  },
  persianNum: {
    fontFamily: textStyles.regular,
    fontSize: 12,
    color: colorPalette.purple700,
    marginHorizontal: 28,
    marginTop: 4,
    minHeight: 30,
  },
  ErrorNum: {
    fontFamily: textStyles.regular,
    fontSize: 12,
    color: colorPalette.secondary,
    marginHorizontal: 28,
    marginTop: 4,
    minHeight: 30,
    textAlign: 'right',
  },
  otherWay: {
    fontFamily: textStyles.regular,
    fontSize: 14,
    color: colorPalette.grey6,
    marginBottom: 4,
    marginHorizontal: 16,
  },
  list: {
    paddingVertical: 8,
    alignSelf: 'flex-end',
  },
  itemContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    borderWidth: 1,
    borderRadius: 14,
    borderColor: colorPalette.grey1,
    paddingVertical: 8,
    paddingHorizontal: 12,
  },
  itemUnit: {
    fontFamily: textStyles.regular,
    fontSize: 10,
  },
  itemNumber: {
    fontFamily: textStyles.bold,
    fontSize: 14,
  },
  currentContainer: {
    marginTop: 64,
    backgroundColor: colorPalette.grey0_5,
    alignSelf: 'stretch',
    borderRadius: 18,
    marginHorizontal: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 10,
  },
  currentNumber: {
    fontFamily: textStyles.bold,
    fontSize: 18,
    color: colorPalette.grey8_5,
  },
  currentUnit: {
    fontFamily: textStyles.regular,
    fontSize: 14,
  },
  currentTitle: {
    fontFamily: textStyles.regular,
    fontSize: 14,
    color: colorPalette.grey6,
  },
  disabledButton: {
    backgroundColor: colorPalette.oldPrimaryLight,
  },
});
